// extracted by mini-css-extract-plugin
export default {"loading_icon":"ShieldProcessing_loading_icon__WA6fl","spinningLoading":"ShieldProcessing_spinningLoading__irgou"};